import React, { useState, useEffect } from "react";
import {
  Container,
  Grid,
  Typography,
  TextField,
  Select,
  MenuItem,
  Card,
  CardContent,
  InputLabel,
  InputAdornment,
  FormHelperText,
  FormControl,
  Button,
  Input,
} from "@material-ui/core";
import { useQuery } from "react-query";
import IconButton from "@material-ui/core/IconButton";
import Visibility from "@material-ui/icons/Visibility";
import { getMaestras } from "../../actions/maestras-actions";
import { createPersonExternal } from "../../actions/userExternal-actions";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Logo from "../../images/LOGO_CSC_HORINZONTAL.png";
import ModalConfirm from "../../utils/form/modalConfirmBase";
import ConfirmDialog from "../../utils/form/confirmDialog";
import * as yup from "yup";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import LogoZabug from "../../images/logoZabug.jpeg";
import { styles } from "./styles";
import { ERROR_MESSAGE, REQUIRED_MESSAGE } from "../../constants";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import deLocale from "date-fns/locale/es";
import Utils from "../../utils/utils";
import { TextMaskCustom } from "../../pages/curriculumVitae/help";
import _ from "lodash";
import TitleCase from "react-title-case";
import moment from "moment";

const style = {
  paper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  form: {
    width: "100%",
    marginTop: "5%",
    " &$.MuiGrid-spacing-xs-2 > .MuiGrid-item": {
      padding: "5px !important",
    },
  },
  submit: {
    display: "flex",
    justifyContent: "center",
  },
  inputsForm: {
    " &$.MuiGrid-spacing-xs-2 > .MuiGrid-item": {
      padding: "5px !important",
    },
  },
  patuu: {
    height: 52,
  },

  title: {
    textAlign: "center",
    fontWeight: 700,
    fontSize: 34,
  },

  subTitle: {
    fontSize: 11,
    color: "#099F9F",
    textAlign: "center",
  },

  gridWrapper: {
    paddingRight: "25px",
    marginLeft: 10,
  },
  imgGradient: {},
};

const defaultValues = {
  firstName: "",
  surname: "",
  dateBirth: null,
  document: "",
  documentType: "",
  Document: "",
  password: "",
  email: "",
  phone: null,
};

const RegistrarUsuario = (props) => {
  window.localStorage.removeItem("token_app");

  const classes = styles();

  const maxDate = Utils.getFormattedDateMMddyyyy(new Date(), ".");

  const [valueDocument, setValueDocument] = useState({});
  const [showTelephoneMessage, setShowTelephoneMessage] = useState(false);
  const [validateNumber, setValidateNumber] = useState(false);
  const [telephoneMessage, setTelephoneMessage] = useState(
    "Ingrese mínimo 10 dígitos"
  );
  const [maestras, setMaestras] = useState({
    estadoCivil: [],
    generos: [],
    nivelFormacion: [],
    respuestaAfirmacionNegacion: [],
    tallaCalzado: [],
    tallaLetras: [],
    tallaNumerosFemenino: [],
    tallaNumerosMasculino: [],
    tipoDocumnetoIdentificacion: [],
  });
  const [showCellTelephoneMessage, setShowCellTelephoneMessage] =
    useState(false);

  const [usuario, setUsuario] = useState({
    username: "admin",
    reValidatePassword: false,
    showPassword: false,
  });
  const [message, setMessage] = useState({
    description: "",
    textButtonSubmit: "",
    handleClick: () => {},
    handleClickOut: () => {},
    oneButtons: false,
    type: "",
    open: false,
  });

  const [disabledOnsubmit, setDisabledOnsubmit] = useState(false);
  const [valuesUser, setValuesUser] = useState({
    secondName: "",
    secondSurname: "",
    documentType: "",
    phone: "",
  });

  const [confirm, setConfirm] = useState({
    open: false,
    question: "",
    handleClickOut: () => {},
    handleClick: () => {},
  });

  const validateDates = () => {
    const currentyear=moment().year()-1;
    return moment(currentyear+"-12-31").toDate();
  }

  const schema = yup.object().shape({
    firstName: yup.string()
      .required(REQUIRED_MESSAGE)
      .min(3, "Ingrese mínimo 3 caracteres")
      .max(80, "Ingrese máximo 80 caracteres")
      .matches(
        /^(([A-Za-zÀ-ÿ])+[ ]?)*$/g,
        "Ingrese un nombre válido"
      ),
    secondName: !valuesUser.secondName
      ? null
      : yup
          .string()
          .notRequired()
          .min(3, "Ingrese mínimo 3 caracteres")
          .max(80, "Ingrese máximo 80 caracteres")
          .matches(
            /^(([A-Za-zÀ-ÿ])+[ ]?)*$/g,
            "Ingrese un nombre válido"
          ),

    surname: yup
      .string()
      .required(REQUIRED_MESSAGE)
      .min(3, "Ingrese mínimo 3 caracteres")
      .max(80, "Ingrese máximo 80 caracteres")
      .matches(
        /^(([A-Za-zÀ-ÿ])+[ ]?)*$/g,
        "Ingrese un apellido válido"
      ),
    secondSurname: !valuesUser.secondSurname
      ? null
      : yup
          .string()
          .notRequired()
          .min(3, "Ingrese mínimo 3 caracteres")
          .max(80, "Ingrese máximo 80 caracteres")
          .matches(
            /^(([A-Za-zÀ-ÿ])+[ ]?)*$/g,
            "Ingrese un apellido válido"
          ),
    dateBirth: yup
      .date()
      .nullable()
      .required(REQUIRED_MESSAGE)
      .min(
        new Date(1899, 11, 31, 23, 59, 29),

        `No puede ser menor a la fecha de 1900`
      )
      .max(validateDates(), `La fecha debe ser menor al año actual`)
      .nullable()
      .typeError("Ingrese un formato de fecha válido"),
    documentType: yup.string().nullable().required(REQUIRED_MESSAGE),
    documentNumber: validateNumber
      ? yup
          .string()
          .required(REQUIRED_MESSAGE)
          .min(3, "Ingrese mínimo 3 caracteres")
          .max(16, "Ingrese máximo 16 caracteres")
          .matches(
            /^([0-9A-Za-zÑñ]{0,16})$/,
            "Ingrese un número de identificación válido"
          )
      : yup
          .string()
          .required(REQUIRED_MESSAGE)
          .min(3, "Ingrese mínimo 3 caracteres")
          .max(16, "Ingrese máximo 16 caracteres")
          .matches(
            /^([0-9]{0,16})$/,
            "Ingrese un número de identificación válido"
          ),
    externalEmail: yup
      .string()
      .required(REQUIRED_MESSAGE)
      .email("Ingrese un correo electrónico válido")
      .min(8, "Ingrese mínimo 8 caracteres")
      .max(100, "Ingrese máximo 100 caracteres"),
    gender: yup.string().required(REQUIRED_MESSAGE),
    cellPhoneNumber: yup
      .string()
      .nullable()
      .transform((value) =>
        value
          .replace(/\s+/g, "")
          .split(" ")
          .join("")
          .replace("(", "")
          .replace(")", "")
          .replace("-", "")
          .replace(" ", "")
          .trim()
      )
      .required(REQUIRED_MESSAGE)
      .min(10, "Ingrese mínimo 10 dígitos"),
    phone: !valuesUser.phone ? null : yup
      .string()
      .nullable()
      .notRequired()
      .min(10, "Ingrese mínimo 10 dígitos")
      .transform((value) =>
        value
        .replace(/\(/g, "")
        .replace(/\)/g, "")
        .replace(/\-/g, "")
        .replace(/\s+/g, "")
      ),
    password: yup
      .string()
      .required(REQUIRED_MESSAGE)
      .max(15, "Ingrese máximo 15 caracteres")
      .min(8, "Ingrese mínimo 8 caracteres")
      .matches(/(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])/, 'Ingrese al menos una minúscula, una mayúscula, un número y un carácter especial'),
    validatePassword: yup
      .string()
      .nullable()
      .required(REQUIRED_MESSAGE)
      .test(
        "match",
        "Las contraseñas no coinciden",
        function (validatePassword) {
          return validatePassword === this.parent.password;
        }
      ),
  });

  window.localStorage.removeItem("token_app");

  const { register, handleSubmit, control, formState:{errors}, setValue, watch, getValues } = useForm({
    resolver: yupResolver(schema),
    defaultValues,
    mode: "all",
    reValidateMode: "onChange",
  });

  const handleOnchageDocument = (e) => {
    const {name, value} = e.target;
    setValueDocument({
      valueDocument,
      [name] : value,
    })
    setValue("documentNumber", "");
  }

  const handleClickShowPasswordRevalidate = () => {
    setUsuario({ ...usuario, reValidatePassword: !usuario.reValidatePassword });
  };

  const handleMouseDownPasswordRevalidate = (event) => {
    event.preventDefault();
  };

  const handleClickShowPassword = () => {
    setUsuario({ ...usuario, showPassword: !usuario.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleClickOut = () => props.history.push("/auth/login");

  const handleClickClose = () => {
    setDisabledOnsubmit(false);
    setMessage({...message, open: false});
  }

  const getListaMaestras = async () => {
    const response = await getMaestras();
    setMaestras(response.data.maestras);
    return response.data.maestras;
  };

  const { data: dataListaMaestras, status: statusListaMaestras } = useQuery(
    "listaMaestras",
    getListaMaestras
  );

  const validateTelephoneNumber = (value, name) => {
    let valid = true;
    let telephoneNumber = value
      .replace(/\s+/g, "")
      .split(" ")
      .join("")
      .replace("(", "")
      .replace(")", "")
      .replace("-", "")
      .replace(" ", "")
      .trim();
    if (telephoneNumber.length < 10) {
      name === "phone"
        ? setShowTelephoneMessage(true)
        : setShowCellTelephoneMessage(true);
      valid = false;
    } else {
      name === "phone"
        ? setShowTelephoneMessage(false)
        : setShowCellTelephoneMessage(false);
      valid = true;
    }
    return valid;
  };

  const onSubmit = (data) => {
    setDisabledOnsubmit(true);

    var validCellPhoneNumber = validateTelephoneNumber(
      data.cellPhoneNumber,
      "cellPhoneNumber"
    );

    if (!validCellPhoneNumber ) {
      setDisabledOnsubmit(false);
      return false;
    }

    setMessage({
      description: "¿Está seguro que desea crear el registro? ",
      textButtonSubmit: "Aceptar",
      handleClick: () => handleClick(data),
      handleClickOut: () => handleClickClose(),
      type: "WARNING",
      open: true,
    });
  };

  useEffect(() => {
    setValue("gender", 1);
  }, []);

  const clear = () => {
    setValue("firstName", "");
    setValue("secondName", null);
    setValue("surname", "");
    setValue("secondSurname", null);
    setValue("dateBirth", null);
    setValue("documentType", null);
    setValue("documentNumber", "");
    setValue("externalEmail", "");
    setValue("phone", "");
    setValue("cellPhoneNumber", "");
    setValue("gender", "");
    setValue("password", "");
    setValue("validatePassword", "");
  };

  const handleClick = (data) => {
    setMessage({ ...message, open: false });
    const convertToParse = {
      firstName: data.firstName,
      secondName: data.secondName ? data.secondName : null,
      surname: data.surname,
      secondSurname: data?.secondSurname ? data?.secondSurname : null,
      //dateBirth: moment(data.dateBirth).format('YYYY-MM-DD'),
      dateBirth: moment(data.dateBirth).format("YYYY-MM-DDTHH:mm"),
      documentType: data?.documentType
        ? data?.documentType
        : valuesUser.documentType,
      documentNumber: data.documentNumber,
      externalEmail: data.externalEmail,
      phone: data.phone ? parseInt(data.phone) : null,
      cellPhoneNumber: data.cellPhoneNumber
        ? parseInt(data.cellPhoneNumber)
        : 0,
      gender: data.gender === "1" ? null : data.gender,
      creationUser: "DEVELOPER",
      password: data.password,
    };
    const createPerson = async () => {
      const response = await createPersonExternal(convertToParse);
      if (response?.status === 200 || response?.status === 201) {
        setMessage({
          description: `Usuario creado exitosamente`,
          textButtonSubmit: "Iniciar Sessión",
          handleClick: () => handleClickOut(),
          oneButtons: true,
          type: "SUCCESS",
          open: true,
        });
        setTimeout(function () {
          clear();
        }, 2000);
      } else if (response?.status > 399 && response?.status !== 401 && response?.status !==403) {
        setMessage({
          description: response?.data ? response?.data?.detail : ERROR_MESSAGE,
          textButtonSubmit: "ACEPTAR",
          handleClick: () => handleClickOut(),
         // handleClick: () => validateCode(),
          oneButtons: true,
          type: "WARNING",
          open: true,
        });
      } else {
        setMessage({
          description: ERROR_MESSAGE,
          textButtonSubmit: "ACEPTAR",
          handleClick: () => handleClickClose(),
          oneButtons: true,
          type: "WARNING",
          open: true,
        });
      }
    };
    createPerson();
  };

  const handleUserKeyPress = (e) => {
    let invalidChars = ["-", "e", "+", "E", ".", ","];
    if (invalidChars?.includes(e.key)) {
      e.preventDefault();
    }

    const { value, name } = e.target;
    const newValue = value
      .replace(/\s+/g, "")
      .split(" ")
      .join("")
      .replace("(", "")
      .replace(")", "")
      .replace("-", "")
      .replace(" ", "")
      .trim();
    if (name === "phone" && parseInt(newValue) < 999999999) {
      setShowTelephoneMessage(true);
    } else {
      setShowTelephoneMessage(false);
    }
  };

  const validateSecondName = watch("secondName");
  const validateSecondSurname = watch("secondSurname");

  const handleOnchange = (e) => {
    const { name, value } = e.target;
    setValuesUser({ ...valuesUser, [name]: value })
  
  };

  const handleUserKeyPressDocumento = (e) => {
    var form = getValues();
    if (form.documentType !== "PP") {
      let validChars = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];
      if (!validChars.includes(e.key)) {
        e.preventDefault();
      }
    }
  };

  useEffect(() => {
    if (
      watch("phone")
        .replace("(", "")
        .replace(")", "")
        .replace("-", "")
        .replace(" ", "")
        .trim() !== ""
    ) {
      setValuesUser({ ...valuesUser, phone: true });
    } else {
      setValuesUser({ ...valuesUser, phone: false });
    }
  }, [
    watch("phone")
      ?.replace("(", "")
      ?.replace(")", "")
      ?.replace("-", "")
      ?.replace(" ", "")
      ?.trim() !== "",
  ]);

  const valueTypeDocument = (watch("documentType") === "PP");

  useEffect(() => {
    if (valueTypeDocument) {
      setValidateNumber(true);
    }else{
      setValidateNumber(false);
    }

}, [valueTypeDocument, valueDocument ]);


  return (
    <div className={classes.backgroundRegister}>
      <ConfirmDialog
        open={confirm.open}
        body={confirm.question}
        handleClickOut={confirm.handleClickOut}
        handleClick={confirm.handleClick}
      />
      <Grid container className={classes.policy} alignItems="center">
        <Grid
          item
          xs={12}
          md={12}
          lg={8}
          className={classes.containerCardRegister}
        >
          <Card style={{ borderRadius: 16, opacity: "80%" }}>
            <CardContent
              style={{
                display: "flex",
                flexDirection: "column",
                background: "rgba(255, 255, 255, 0.8)",
              }}
            >
              <Grid
                container
                space={2}
                className={classes.classContainerLogosRegister}
              >
                <Grid
                  item
                  xs={7}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <img
                    src={Logo}
                    width="90%"
                    height="100%"
                    alt=""
                    // className={classes.borderImageLogo}
                  />
                  <div
                    item
                    xs={1}
                    style={{
                      fontSize: 60,
                      color: "#80808091",
                      position: "relative",
                      bottom: 25,
                    }}
                  >
                    .
                  </div>
                </Grid>
                <Grid item xs={5}>
                  <img src={LogoZabug} width="60%" height="70%" alt="" />
                </Grid>
              </Grid>
              <Grid item xs={12} md={12} style={style.gridWrapper}>
                <Container component="main" maxWidth="lg" justify="center">
                  <div style={style.paper}>
                    <Typography component="h1" style={style.title}>
                      Registro
                    </Typography>
                    <a href
                      onClick={() => props.history.push("/auth/login")}
                      className={classes.forgot}
                      // style={{color: '', fontSize: 15}}
                    >
                      Iniciar Sesión
                    </a>
                  </div>
                  <form style={style.form} onSubmit={handleSubmit(onSubmit)}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6} lg={6} style={{ height: 73 }}>
                        <FormControl 
                          variant="outlined"
                          fullWidth
                          size="small"
                          error={
                            !!errors.hasOwnProperty("firstName") &&
                            errors["firstName"].message
                          }
                        >
                          <Controller
                            control={control}
                            name="firstName"
                            defaultValue=""
                            rules={{ required: true }}
                            render={({field}) => (
                              <TextField
                                {...field}
                                InputLabelProps={{ shrink: true }}
                                inputRef={register}
                                name="firstName"
                                variant="outlined"
                                placeholder="Primer Nombre *"
                                //value={capitalizeName}
                                //onChange={toUpperCaseName}
                                className={classes.dropdown}
                                fullWidth
                                size="small"
                                type="text"
                                label="Primer nombre *"
                                error={
                                  errors.hasOwnProperty("firstName") &&
                                  errors["firstName"].message
                                }
                              />
                            )}
                          />
                          <FormHelperText style={{color: "#f44336", paddingLeft: 14}} >
                                {errors.hasOwnProperty('firstName') && errors['firstName'].message}                          
                            </FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={6} lg={6} style={{ height: 73 }}>
                        <TextField
                          InputLabelProps={{ shrink: true }}
                          inputRef={register}
                          name="secondName"
                          placeholder="Segundo Nombre"
                          variant="outlined"
                          onChange={handleOnchange}
                          className={classes.dropdown}
                          fullWidth
                          size="small"
                          type="text"
                          label="Segundo nombre"
                          error={
                            validateSecondName !== ""
                              ? errors.hasOwnProperty("secondName") &&
                                errors["secondName"].message
                              : null
                          }
                          helperText={
                            validateSecondName !== ""
                              ? errors.hasOwnProperty("secondName") &&
                                errors["secondName"].message
                              : null
                          }
                        />
                        
                      </Grid>
                      <Grid item xs={12} md={6} lg={6} style={{ height: 73 }}>
                        <TextField
                          InputLabelProps={{ shrink: true }}
                          inputRef={register}
                          name="surname"
                          variant="outlined"
                          placeholder="Primer Apellido *"
                          className={classes.dropdown}
                          fullWidth
                          type="text"
                          size="small"
                          label="Primer Apellido *"
                          error={
                            errors.hasOwnProperty("surname") &&
                            errors["surname"].message
                          }
                          helperText={
                            errors.hasOwnProperty("surname") &&
                            errors["surname"].message
                          }
                        />
                      </Grid>
                      <Grid item xs={12} md={6} lg={6} style={{ height: 73 }}>
                        <TextField
                          InputLabelProps={{ shrink: true }}
                          inputRef={register}
                          type="text"
                          name="secondSurname"
                          placeholder="Segundo Apellido"
                          className={classes.dropdown}
                          variant="outlined"
                          onChange={handleOnchange}
                          fullWidth
                          size="small"
                          label="Segundo Apellido"
                          error={
                            validateSecondSurname !== ""
                              ? errors.hasOwnProperty("secondSurname") &&
                                errors["secondSurname"].message
                              : null
                          }
                          helperText={
                            validateSecondSurname !== ""
                              ? errors.hasOwnProperty("secondSurname") &&
                                errors["secondSurname"].message
                              : null
                          }
                        />
                      </Grid>
                      <Grid item xs={12} md={6} lg={6} style={{ height: 73 }}>
                        <FormControl fullWidth>
                          <MuiPickersUtilsProvider
                            locale={deLocale}
                            utils={DateFnsUtils}
                          >
                            <Controller
                              as={
                                <KeyboardDatePicker
                                  fullWidth
                                  inputVariant="outlined"
                                  variant="inline"
                                  name="dateBirth"
                                  format="dd/MM/yyyy"
                                  className={classes.dropdown}
                                  label="Fecha de nacimiento *"
                                  InputLabelProps={{ shrink: true }}
                                  error={
                                    !!errors.hasOwnProperty("dateBirth") &&
                                    errors["dateBirth"].message
                                  }
                                  helperText={
                                    errors.hasOwnProperty("dateBirth") &&
                                    errors["dateBirth"].message
                                  }
                                  minDate={"01.01.1900"}
                                  minDateMessage={"No puede ser menor a 1900"}
                                  maxDate={maxDate}
                                />
                              }
                              control={control}
                              name="dateBirth"
                              placeholder="dd/mm/yyyy"
                              size="small"
                            />
                          </MuiPickersUtilsProvider>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={6} lg={6} style={{ height: 73 }}>
                        <FormControl
                          variant="outlined"
                          fullWidth
                          size="small"
                          error={
                            !!errors.hasOwnProperty("documentType") &&
                            errors["documentType"].message
                          }
                        >
                          <InputLabel htmlFor="outlined-select-documentType" shrink={true}>
                            Tipo de documento *
                          </InputLabel>
                          <Controller
                            fullWidth
                            control={control}
                            inputRef={register}
                            name="documentType"
                            size="small"
                            render={(props) => (
                              <Select
                              label="Tipo de Documento"
                                notched={true}
                                className={classes.dropdown}
                                inputProps={{
                                  name: "documentType",
                                  id: "outlined-select-documentType",
                                }}
                                onChange={(e) => {
                                  props.onChange(e);
                                  handleOnchageDocument(e);
                                }}
                              >
                                {maestras.tipoDocumnetoIdentificacion.map(
                                  (document) => (
                                    <MenuItem
                                      className={classes.menuItem}
                                      key={document.key}
                                      value={document.key}
                                    >
                                      {document.value}
                                    </MenuItem>
                                  )
                                )}
                              </Select>
                            )}
                          />
                          <FormHelperText>
                            {errors.hasOwnProperty("documentType") && errors["documentType"].message}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={6} lg={6} style={{ height: 73 }}>
                        <TextField
                          InputLabelProps={{ shrink: true }}
                          inputRef={register}
                          type="text"
                          //type={ validateNumber ? "text" : "number" }
                          name="documentNumber"
                          defaultValue=""
                          className={classes.dropdown}
                          placeholder="Número de documento"
                          variant="outlined"
                          fullWidth
                          size="small"
                          label="Número de documento *"
                          error={
                            errors.hasOwnProperty("documentNumber") &&
                            errors["documentNumber"].message
                          }
                          helperText={
                            errors.hasOwnProperty("documentNumber") &&
                            errors["documentNumber"].message
                          }
                          onKeyPress={handleUserKeyPressDocumento }
                        />
                      </Grid>
                      <Grid item xs={12} md={6} lg={6} style={{ height: 73 }}>
                        <FormControl
                          variant="outlined"
                          fullWidth
                          size="small"
                          error={
                            !!errors.hasOwnProperty("gender") &&
                            errors["gender"].message
                          }
                        >
                          <InputLabel
                            htmlFor="outlined-select-gender"
                            shrink={true}
                          >
                            Género
                          </InputLabel>
                          <Controller
                            fullWidth
                            control={control}
                            inputRef={register}
                            className={classes.dropdown}
                            defaultValue="Seleccione"
                            label="Género"
                            name="gender"
                            notched={true}
                            size="small"
                            inputProps={{
                              name: "gender",
                              id: "outlined-select-gender",
                            }}
                            as={
                              <Select>
                                <MenuItem value={1} disabled>
                                  <em>Seleccione</em>
                                </MenuItem>
                                {statusListaMaestras === "success" &&
                                  _.sortBy(
                                    dataListaMaestras.generos,
                                    (o) => o.value
                                  ).map((gender) => (
                                    <MenuItem
                                      className={classes.menuItem}
                                      key={gender.index}
                                      value={gender.key}
                                    >
                                      <TitleCase string={gender.value} />
                                    </MenuItem>
                                  ))}
                              </Select>
                            }
                          />
                          <FormHelperText>
                            {errors.hasOwnProperty("gender") &&
                              errors["gender"].message}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={6}
                        style={{ marginTop: 15, height: 73 }}
                      >
                        <FormControl
                          fullWidth
                          style={{ marginTop: "0px" }}
                          error={
                            !!errors.hasOwnProperty("cellPhoneNumber") &&
                            errors["cellPhoneNumber"].message
                          }
                        >
                          <InputLabel
                            htmlFor="cellPhoneNumber"
                            style={{
                              zIndex: 2,
                              marginTop: "-15px",
                              paddingLeft: "10px",
                            }}
                          >
                            No. Celular *
                          </InputLabel>
                          <Input
                            id="cellPhoneNumber"
                            inputComponent={TextMaskCustom}
                            variant="outlined"
                            //className={classes.dropdown}
                            type="text"
                            notched={true}
                            inputRef={register}
                            className={classes.formField}
                            style={{ marginTop: "0px" }}
                            inputProps={{
                              style: {
                                height: "18px",
                                borderRadius: "8px",
                                paddingBottom: "0px",
                                fontSize: 14,
                                paddingLeft: "12px",
                              },
                            }}
                            onKeyPress={handleUserKeyPress}
                            name="cellPhoneNumber"
                            size="small"
                          />
                          <FormHelperText style={{ color: "#f44336" }}>
                            {errors.hasOwnProperty("cellPhoneNumber") &&
                              errors["cellPhoneNumber"].message}
                          </FormHelperText>
                          <FormHelperText style={{ color: "#f44336" }}>
                            {!errors.hasOwnProperty("cellPhoneNumber") &&
                              showCellTelephoneMessage &&
                              telephoneMessage}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={6} lg={6}>
                        <FormControl
                          className={classes.formControl}
                          variant="outlined"
                          size="small"
                        >
                          <InputLabel
                            htmlFor="outlined-adornment-password"
                            size="small"
                            error={
                              errors.hasOwnProperty("password") &&
                              errors["password"].message
                            }
                            shrink={true}
                          >
                            Contraseña *
                          </InputLabel>
                          <OutlinedInput
                            inputRef={register}
                            variant="outlined"
                            type={usuario.showPassword ? "text" : "password"}
                            label="Contraseña *"
                            className={classes.dropdown}
                            defaultValue=""
                            placeholder="Contraseña *"
                            name="password"
                            notched={true}
                            size="small"
                            error={
                              errors.hasOwnProperty("password") &&
                              errors["password"].message
                            }
                            endAdornment={
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                  edge="end"
                                >
                                  {usuario.showPassword ? (
                                    <Visibility />
                                  ) : (
                                    <VisibilityOff />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            }
                          />
                          <FormHelperText style={{ color: "#f44336" }}>
                            {errors.hasOwnProperty("password") &&
                              errors["password"].message}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={6}
                        style={{ marginTop: 15 }}
                      >
                        <FormControl
                          fullWidth
                          style={{ marginTop: "0px" }}
                          error={
                            !!errors.hasOwnProperty("phone") &&
                            errors["phone"].message
                          }
                        >
                          <InputLabel
                            htmlFor="phone"
                            style={{
                              zIndex: 2,
                              marginTop: "-7px",
                              paddingLeft: "10px",
                            }}
                          >
                            No. Teléfono
                          </InputLabel>
                          <Input
                            id="phone"
                            inputComponent={TextMaskCustom}
                            variant="outlined"
                            type="text"
                            notched={true}
                            inputRef={register}
                            className={classes.formField}
                            name="phone"
                            style={{ marginTop: "0px" }}
                            inputProps={{
                              style: {
                                height: "18px",
                                borderRadius: "8px",
                                paddingBottom: "0px",
                                fontSize: 14,
                                paddingLeft: "12px",
                              },
                            }}
                            onKeyPress={handleUserKeyPress}
                            size="small"
                          />
                          <FormHelperText style={{ color: "#f44336" }}>
                            {errors.hasOwnProperty("phone") &&
                              errors["phone"].message}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={6} lg={6}>
                        <FormControl fullWidth variant="outlined" size="small">
                          <InputLabel
                            htmlFor="outlined-adornment-validatePassword"
                            size="small"
                            error={
                              errors.hasOwnProperty("validatePassword") &&
                              errors["validatePassword"].message
                            }
                            shrink={true}
                          >
                            Repetir contraseña *
                          </InputLabel>
                          <OutlinedInput
                            inputRef={register}
                            variant="outlined"
                            type={
                              usuario.reValidatePassword ? "text" : "password"
                            }
                            label="Repetir contraseña *"
                            defaultValue=""
                            className={classes.dropdown}
                            placeholder="Repetir contraseña *"
                            notched={true}
                            name="validatePassword"
                            size="small"
                            error={
                              errors.hasOwnProperty("validatePassword") &&
                              errors["validatePassword"].message
                            }
                            endAdornment={
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPasswordRevalidate}
                                  onMouseDown={
                                    handleMouseDownPasswordRevalidate
                                  }
                                  edge="end"
                                >
                                  {usuario.reValidatePassword ? (
                                    <Visibility />
                                  ) : (
                                    <VisibilityOff />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            }
                          />
                          <FormHelperText style={{ color: "#f44336" }}>
                            {errors.hasOwnProperty("validatePassword") &&
                              errors["validatePassword"].message}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={6} lg={6} style={{ height: 73 }}>
                        <TextField
                          InputLabelProps={{ shrink: true }}
                          inputRef={register}
                          type="text"
                          placeholder="ejemplo@correo.com"
                          name="externalEmail"
                          defaultValue=""
                          className={classes.dropdown}
                          variant="outlined"
                          fullWidth
                          size="small"
                          label="Correo electrónico*"
                          error={
                            errors.hasOwnProperty("externalEmail") &&
                            errors["externalEmail"].message
                          }
                          helperText={
                            errors.hasOwnProperty("externalEmail") &&
                            errors["externalEmail"].message
                          }
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={6}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Button
                          style={{ width: "48% " }}
                          type="submit"
                          fullWidth
                          variant="contained"
                          className={classes.buttonBack}
                          onClick={() => props.history.push("/auth/login")}
                          disableElevation
                        >
                          Regresar
                        </Button>
                        <Button
                          style={{ width: "48% " }}
                          type="submit"
                          disabled={disabledOnsubmit}
                          fullWidth
                          variant="contained"
                          className={classes.submit}
                        >
                          Enviar
                        </Button>
                      </Grid>
                    </Grid>
                  </form>
                  <ModalConfirm
                    description={message.description}
                    textButtonSubmit={message.textButtonSubmit}
                    handleClick={message.handleClick}
                    handleClickOut={message.handleClickOut}
                    oneButtons={message.oneButtons}
                    type={message.type}
                    open={message.open}
                  />
                </Container>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default RegistrarUsuario;
